import { CheckCircleOutline, DoDisturbOn, Label } from "@mui/icons-material";
import {
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import {
    adderCategoriesReset,
    GetSingleAdderGroupMethod,
    UpdateAdderCategoryMethod,
} from "../../Redux/AddersCategoriesSlice/AddersCategoriesSlice";

const EditAdderCategory = () => {
    const { id } = useParams();

    const { adders_category, isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.adders_categories
    );

    const AdderVal = adders_category?.data || [];

    const dispatch = useDispatch();

    const CallNotificationMethod = async () => {
        toast.success("The data has been modified successfully");
        await dispatch(adderCategoriesReset());
    };

    const formik = useFormik({
        initialValues: {
            id: "",
            name: "",
            type: "",
            status: 0,
        },
        onSubmit: async (values) => {
            await dispatch(UpdateAdderCategoryMethod(values));
            await CallNotificationMethod();
        },
    });

    const allGroupsTypes = [
        { name: "dropdown" },
        { name: "checkbox" },
        { name: "radio" },
    ];

    useEffect(() => {
        const GetAdderData = async () => {
            await dispatch(GetSingleAdderGroupMethod(id));
            await dispatch(adderCategoriesReset());
        };
        GetAdderData();
    }, [dispatch, id]);

    useEffect(() => {
        if (AdderVal) {
            formik.values.id = AdderVal?.id || "";
            formik.values.name = AdderVal?.name || "";
            formik.values.type = AdderVal?.type || "";
            formik.values.status = AdderVal?.status || 0;
        }
    }, [AdderVal]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const reset = async () => {
                await dispatch(adderCategoriesReset());
            };
            reset();
        }
    }, [isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    <Container>
                        <FormHeading> Edit Group </FormHeading>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid mt={2} container columns={12} spacing={2}>
                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="name"
                                        name="name"
                                        label="Name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item mb={1} xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                            Type
                                        </InputLabel>
                                        <Select
                                            id="type"
                                            name="type"
                                            label="Type"
                                            value={formik.values.type}
                                            onChange={formik.handleChange}
                                        >
                                            {allGroupsTypes?.map((key, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={key.name}
                                                >
                                                    {key.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <PrimaryButton fullWidth type="submit">
                                {isLoading ? "Loading..." : "Edit"}
                            </PrimaryButton>
                        </form>
                    </Container>
                </>
            )}
        </>
    );
};

export default EditAdderCategory;
